import { Phone, MessageCircle } from "lucide-react";
import { PHONE, WHATSAPP_URL, CALL_URL, trackWhatsAppClick, trackCallClick } from "@/lib/constants";

export default function Header() {
  return (
    <header data-testid="header-nav" className="sticky top-0 z-50 backdrop-blur-xl bg-white/90 border-b border-stone-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        <a href="/" data-testid="header-logo" className="flex items-center">
          <img
            src="https://vingrace.com/wp-content/uploads/2023/06/vingrace-1.png"
            alt="Vin Grace"
            className="h-10 sm:h-12 w-auto object-contain"
          />
        </a>
        <div className="flex items-center gap-2 sm:gap-3">
          <a
            href={CALL_URL}
            data-testid="header-call-btn"
            onClick={() => trackCallClick(CALL_URL)}
            className="hidden sm:flex items-center gap-2 bg-stone-100 hover:bg-stone-200 text-stone-800 rounded-xl px-4 py-2.5 text-sm font-semibold transition-colors"
          >
            <Phone className="w-4 h-4" />
            +91 {PHONE}
          </a>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-whatsapp-btn"
            onClick={trackWhatsAppClick}
            className="flex items-center gap-2 bg-[#25D366] hover:bg-[#1da851] text-white rounded-xl px-4 py-2.5 text-sm font-semibold transition-colors"
          >
            <MessageCircle className="w-4 h-4" />
            <span className="hidden sm:inline">WhatsApp Us</span>
            <span className="sm:hidden">Chat</span>
          </a>
        </div>
      </div>
    </header>
  );
}
